import { filter, sortBy } from 'lodash'
import { call, put, takeEvery, select } from 'redux-saga/effects'

import StadiumRemote from '../remote/stadiumRemote'

import { fetchPromotions, fetchPromotionsSucceeded, fetchPromotionsFailed } from '../actions/promotion'
import { getCurrentMenu } from '../selectors/menus'

function* fetchPromotionsSaga(params) {
  const venueUuid = process.env.REACT_APP_VENUE_UUID
  const menu = yield select(getCurrentMenu)

  try {
    //stand_menu_uuids always need to be present or stadium is going to return a 422
    //that's why we're sending an array with an empty string when current menu is undefined
    const result = yield call(StadiumRemote.getPromotions, venueUuid, [menu?.uuid || ''])
    const activePromotions = filter(result?.data?.promotions, (promotion) => !!promotion?.active)
    const promotions = sortBy(activePromotions, ['name'])

    yield put(fetchPromotionsSucceeded({ promotions }))
  } catch (err) {
    yield put(fetchPromotionsFailed())
  }
}

export function* watchFetchPromotionsSaga() {
  yield takeEvery(fetchPromotions.type, fetchPromotionsSaga)
}
